<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark> Serviços </TitleWidget>
    </v-sheet>

    <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
      <LoadingWidget v-if="loading" />
      <div v-for="(item, index) in items" :key="item.id">
        <div :id="`servico-${item.id}`" class="mb-10">
          <v-row align="center" class="mt-4">
            <v-col cols="12" md="4">
              <v-img :src="files + item.img" contain></v-img>
            </v-col>
            <v-col cols="12" md="8">
              <TitleWidget align="left" class="mb-3">{{
                item.title
              }}</TitleWidget>
              <div v-html="item.text"></div>
            </v-col>
          </v-row>
        </div>
        <v-divider v-if="index < items.length - 1" class="my-10"></v-divider>
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "@/components/widgets/TitleWidget.vue";
import LoadingWidget from "@/components/widgets/LoadingWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest("services").list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;
      this.$rest("services")
        .get({
          save: (state, data) => {
            state.list = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  created() {
    document.title = "Serviços | FACEM";
    this.getList();
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>
